/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// React
import React from "react";

// Zaim engineering components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { IconButton, Tooltip } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteIcon from "@mui/icons-material/Delete";
import ConvertPiComponent from "../edits/ConvertToPI";
import { formatRefId, formatDate } from "../../../utils/format";
import { formatAddressPreview } from "../../../utils/addressHelpers";

export default function buildQuotationTable(
  data,
  onEdit,
  onConvertPi,
  onDelete,
  canConvert = true,
  canDelete = true
) {
  const Client = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = [
    { Header: "Quotation ID", accessor: "refId", align: "left" },
    { Header: "Customer", accessor: "client", width: "35%", align: "left" },
    { Header: "quoted By", accessor: "quotedBy", align: "center" },
    { Header: "created", accessor: "createdAt", align: "center" },
    { Header: "grand total", accessor: "grandTotal", align: "center" },
    // {
    //   Header: "Ship To",
    //   accessor: "shipToAddress",
    //   Cell: ({ value }) => (value ? formatAddressPreview(value) : "-"),
    // },
    // {
    //   Header: "Bill To",
    //   accessor: "billToAddress",
    //   Cell: ({ value }) => (value ? formatAddressPreview(value) : "-"),
    // },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = data.map((item) => {
    return {
      refId: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {formatRefId(item)}
        </MDTypography>
      ),
      client: <Client name={item.customer.store_name} email={item.customer.name} />,
      quotedBy: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.user.name}
        </MDTypography>
      ),
      createdAt: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {formatDate(item.createdAt)}
        </MDTypography>
      ),
      grandTotal: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          ₹{Math.round(item.grandTotal)}
        </MDTypography>
      ),
      // shipToAddress: item.shipToAddress || null,
      // billToAddress: item.billToAddress || null,
      action: (
        <MDBox display="flex" justifyContent="center" alignItems="center">
          {/* Editing a quotation is open to every user type. */}
          <Tooltip title="Edit">
            <IconButton
              color="info"
              size="small"
              onClick={(e) => {
                e.preventDefault();
                onEdit(item.id);
              }}
            >
              <EditNoteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {canConvert && (
            <ConvertPiComponent key={item.id} id={item.id} onConvertPi={onConvertPi} />
          )}
          {canDelete && (
            <Tooltip title="Delete">
              <IconButton
                color="error"
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  onDelete(item.id);
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </MDBox>
      ),
    };
  });

  return { columns, rows };
}
